import {getAllJobsString, getTaskBoardJobs, updateJobAdmin} from "../../service/JobService";
import {isTaskJob} from "./schedulerUtils";
import {buildTaskAdminPayload, buildTaskFormFromJob} from "./taskFormUtils";

export const DEFAULT_SCHEDULER_WORKER_ID = "3";
export const CLEANING_BOARD_MODE = "cleaning";
export const TASK_BOARD_MODE = "task";

export const cleaningStatusOptions = [
    {label: "Pending", value: "Pending", variant: "outline-dark"},
    {label: "Important", value: "Updated", variant: "outline-danger", countKey: "Updated"},
    {label: "Scheduled", value: "Scheduled", variant: "outline-primary"},
    {label: "InProgress", value: "InProgress", variant: "outline-warning"},
    {label: "ReadyForBilling", value: "ReadyForBilling", variant: "outline-success"},
    {label: "Cancelled", value: "Cancelled", variant: "outline-secondary"},
    {label: "X", value: "ALL", variant: "outline-dark"},
];

export const taskStatusOptions = [
    {label: "Pending", value: "Pending", variant: "outline-dark"},
    {label: "Scheduled", value: "Scheduled", variant: "outline-primary"},
    {label: "ReadyForBilling", value: "ReadyForBilling", variant: "outline-success"},
    {label: "X", value: "ALL", variant: "outline-dark"},
];

export const cleaningBoardConfig = {
    mode: CLEANING_BOARD_MODE,
    defaultStatus: "Pending",
    defaultWorkerId: DEFAULT_SCHEDULER_WORKER_ID,
    usesSelectedDate: true,
    statusStorageKey: "schedulerCleaningStatus",
    workerStorageKey: "schedulerCleaningWorkerId",
    legacyStatusStorageKey: "radioValue",
    statusOptions: cleaningStatusOptions,
    emptyMessage: "No Job available on Current Date and Filter",
    fetchJobs: (selectedDate) => getAllJobsString(selectedDate, selectedDate),
    filterJobs: (jobs = []) => jobs.filter((job) => !isTaskJob(job)),
};

export const taskBoardConfig = {
    mode: TASK_BOARD_MODE,
    defaultStatus: "Pending",
    defaultWorkerId: DEFAULT_SCHEDULER_WORKER_ID,
    usesSelectedDate: false,
    statusStorageKey: "schedulerTaskStatus",
    workerStorageKey: "schedulerTaskWorkerId",
    statusOptions: taskStatusOptions,
    emptyMessage: "No Task available for the current filter",
    fetchJobs: () => getTaskBoardJobs(),
    filterJobs: (jobs = []) => jobs.filter((job) => isTaskJob(job)),
    assignWorker: (job, workerId, {selectedDate}) => {
        return updateJobAdmin(buildTaskAdminPayload({
            ...buildTaskFormFromJob(job),
            cos_job_worker: workerId,
            date: selectedDate || job?.date || "",
        }));
    },
    filterWorkerJobs: (job, {selectedDate}) => {
        if (!selectedDate || !job?.date) {
            return true;
        }

        if (job.status !== "ReadyForBilling") {
            return true;
        }

        return String(job.date) >= String(selectedDate);
    },
};
